export default {
    subject: "活动场次",
    round: {
        subject: `<span class="ft-14">第</span> %s <span class="ft-14">场</span>`
    },
    during: {
        subject: "%s 至 %s",
    }
}
